module.exports = __webpack_public_path__ + "img/slots.765b51f7.jpg";